import Promise from 'bluebird';
import 'bootstrap/dropdown';

// To add to window
if (!window.Promise) {
    window.Promise = Promise;
}

/* globals window, document */
/* eslint import/no-extraneous-dependencies: 0, import/no-unresolved: 0 */

// Bootstrap JavaScript Pluggins
require('bootstrap/transition');
require('bootstrap/collapse');
require('bootstrap/modal');
require('bootstrap/tooltip');
require('nos-forms-jquery');

// Waypoint
// require('waypoints/lib/jquery.waypoints');
// require('waypoints/lib/shortcuts/sticky');
//
// const filterWrapper = new window.Waypoint.Sticky({
//     element: $('#filter'),
// });

// IE polyfill for isInteger
Number.isInteger = Number.isInteger || function (value) {
    return typeof value === 'number' &&
        isFinite(value) &&
        Math.floor(value) === value;
};


const mobileSiteNav = {
    mainMenuShow: () => $('#top-nav-bar, #mobileMenuBack').addClass('show'),
    categoriesMenuShow: () => $('#main-nav-bar, #mobileMenuBack').addClass('show'),
    hideMenues: () => $('#top-nav-bar, #main-nav-bar, #mobileMenuBack').removeClass('show'),
};


// SITE NAV
$('#btnMainMenu').on('click', e => {
    e.preventDefault();
    mobileSiteNav.mainMenuShow();
});

$('#btnCategoriesMenu').on('click', e => {
    e.preventDefault();
    mobileSiteNav.categoriesMenuShow();
});

$('#mobileMenuBack').on('click', e => {
    e.preventDefault();
    mobileSiteNav.hideMenues();
});

// FILTER TOGGLE
$('#toggleFilter').on('click', e => {
    e.preventDefault();
    if ($('#filter-wrapper').hasClass('show')) {
        $('#filter-wrapper').removeClass('show');
        return;
    }
    $('#filter-wrapper').addClass('show');
});


// TOGGLE AJAX SPINNER
$(document).on('ajaxStart', function () {
    $('.spinner').show();
}).on('ajaxStop', function () {
    $('.spinner').hide();
});

/**
* Show a toast message, then hide it
* @param {String} msg='Success!' - the message to show
* @param {String} type='success' - the type of bootstrap alert (success, info, danger, warning)
* @param {Object} styles - the alert element css styles
* @requires bootstrap (alerts)
* @requires animate.css (fade)
* @requires font-awesome (check, circle, exclamation, exclamation-triangle)
*/
window.nosToast = function (msg = 'Success!', type = 'success', styles = {}) {

    // Default styles
    // const elementStyles = $.extend({}, {
    //     position: 'fixed',
    //     bottom: 0,
    //     left: 0,
    //     right: 0,
    //     margin: '20px 50px',
    //     'z-index': 9999,
    //     opacity: 0.7,
    // }, styles);

    // If an old toast message is still showing, remove it
    if ($('#nosToast').length) {
        clearTimeout(alertControl);
        $('#nosToast').remove();
    }

    // Default icon
    let icon = 'check';

    // Choose the icon based on the alert type
    switch (type) {
        case 'info':
            icon = 'info-circle';
            break;
        case 'danger':
            icon = 'exclamation-triangle';
            break;
        case 'warning':
            icon = 'exclamation';
            break;
        default:
            icon = 'check';
            break;
    }

    // Build the panel
    const $panel = $(`
        <div class="alert alert-${type} animated fadeInUp" id="nosToast">
            <i class="fas fa-${icon}"></i>&nbsp;
            ${msg}
        </div>
    `);

    // Apply the styles
    // $panel.css(elementStyles);

    // Append the alert
    $('body').append($panel);

    // Hide the alert after 3 seconds
    const alertControl = setTimeout(() => {
        $panel.removeClass('fadeInUp').addClass('fadeOutDown');
        setTimeout(() => $panel.remove(), 1000);
    }, 3000);
};

// Feedback button
$('#provideFeedback').on('click', function (e) {
    e.preventDefault();
    $('#feedbackModal .modal-body').html('<form id="feedbackForm"></form');
    $('#feedbackModal')
        .on('shown.bs.modal', function () {
            $('#feedbackForm').nosForm({
                fields: [
                    {
                        type: 'html',
                        element: '<p>If you would like to provide us with feedback or offer suggestions, just enter them below and hit the <i>Send Feedback</i> button.</p>',
                    },
                    {
                        name: 'feedback',
                        type: 'textarea',
                        required: true,
                        maxlength: 20000,
                        rows: 10,
                    },
                ],
                submit: function (fd) {
                    $('#feedbackSubmitSpinner')
                        .css({
                            width: $('#feedbackSubmit').outerWidth(),
                        })
                        .show();
                    $('#feedbackSubmit, #feedbackCancel').hide();
                    $.ajax({
                        method: 'POST',
                        url: './send-feedback',
                        data: fd,
                    })
                        .done(data => {
                            if (data.success) {
                                $('#feedbackModal').modal('hide');
                                $('#feedbackSubmitSpinner').hide();
                                $('#feedbackSubmit, #feedbackCancel').show();
                            }
                        })
                        .fail((xhr, stat, err) => swal('Error', err, 'error'));
                },
            });
            $('#feedbackSubmit')
                .off('click')
                .on('click', function () {
                    $('#feedbackForm').submit();
                });
        })
        .on('hidden.bs.modal', function () {
            $('#feedbackModal .modal-body').empty();
        })
        .modal();
});
